export default __webpack_public_path__ + "static/media/Travel_06.e18abf54.png";